import {Component, OnInit} from '@angular/core';
import {BehaviorSubject, Observable, map} from "rxjs";
import {FileRef} from "../../model/file-ref";
import {FileService} from "../../services/file.service";
import {MatTableModule} from "@angular/material/table";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {AsyncPipe, NgIf} from "@angular/common";

@Component({
  selector: 'app-admin-uploads',
  templateUrl: './admin-uploads.component.html',
  styleUrls: ['./admin-uploads.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    AsyncPipe,
    NgIf,
  ]
})
export class AdminUploadsComponent implements OnInit {

  files$: Observable<FileRef[]>;
  uploadingFile$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  readonly columns = ['url', 'name', 'actions'];

  constructor(private fileService: FileService) {
  }

  ngOnInit(): void {
    this.files$ = this.fileService.getFiles().pipe(
      map(files => [...files].sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
      ))
    );
  }

  uploadFile($event: any): void {
    if ($event?.target?.files?.length) {
      const file: File = $event.target.files[0];
      this.uploadingFile$.next(true);
      this.fileService.uploadFile(file).then(() => {
        this.uploadingFile$.next(false);
      });
    }
  }

  deleteFile(file: FileRef): void {
    this.fileService.deleteFile(file);
  }
}
